import remoteConfigController from './remoteConfigController'

export default remoteConfigController



// WEBPACK FOOTER //
// ../src/controllers/remoteConfigController/index.js